import React from "react";
import GatewayLogsList from "../../../components/AdminDashboard/GatewayLogs";
import { Box, Typography } from "@mui/material";

const GatewayLogs = () => {
    return (
        <div style={{ padding: "0" }}>
            <Box sx={{ px: 4, pt: 4, pb: 1 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: "#0f172a", mb: 1, letterSpacing: "-0.5px" }}>
                    Gateway Reconciliation
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 2, maxWidth: "800px" }}>
                    Real-time auditing of background tasks enforcing perfect alignment between the Payment Gateway and Askbud-i Billing Engine.
                </Typography>
            </Box>
            <GatewayLogsList />
        </div>
    );
};

export default GatewayLogs;
